module.exports = __webpack_public_path__ + "img/munshi-color.49ecb031.png";